<template>
  <div class="card card-modern">
    <div class="card-header">
      <div class="card-actions">
        <a
          class="card-action card-action-toggle"
          href="#top-selling-articles"
          data-bs-toggle="collapse"
        />
      </div>
      <h2 class="card-title">Najprodavaniji artikli</h2>
    </div>
    <div class="card-body show" id="top-selling-articles">
      <div class="table-responsive">
        <table class="table table-ecommerce-simple table-borderless table-striped mb-1">
          <thead>
            <tr>
              <th></th>
              <th>Artikal</th>
              <th>Cijena</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in dashboardData.topSellingArticles" :key="item.id">
              <td width="72">
                <img :src="`${baseUrl}${item.highlightedImageUrl}`" class="img-fluid" width="45" alt="Porto SmartWatch"
                  v-if="item.highlightedImageUrl" />
                <img src="img/no-image.jpg" class="img-fluid" width="45" alt="Porto SmartWatch" v-else />
              </td>
              <td>
                  <router-link
                    :to="{ name: 'EditArticle', params: { id: item.id } }"
                    class="font-weight-semibold"
                  >

                  {{ item.title }}
                </router-link>
              </td>
              <td width="90">{{ item.price | money2 }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config';

export default {
  name: 'TopSellingArticles',
  computed: {
    baseUrl() {
      return config.baseUrl;
    },
    dashboardData() {
      return this.$store.getters.getDashboardData;
    },
  },
};
</script>